import { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, Modal, Button, message, Spin, Grid, Drawer, Space } from 'antd';
import { DashboardOutlined, FileTextOutlined, UsergroupAddOutlined, LogoutOutlined, UserOutlined, ExclamationCircleOutlined, WalletOutlined, RetweetOutlined, BarChartOutlined, UserSwitchOutlined, CloseOutlined, MenuOutlined, DownOutlined, SwapOutlined, HistoryOutlined } from '@ant-design/icons';
import { withRouter, matchPath } from 'react-router-dom';
import { routes } from '../../routes/Routes';
import { PRIVATE_WEALTH_ADVISOR_ROLE, COMPLIANCE_ADMINISTRATOR_ROLE, UNDERWRITER_BANKER_ROLE, SENIOR_PRIVATE_BANKER_ROLE } from '../../constants/DataConstants';
import "../../assets/dist/BankerUI/Sidebar.css";
import _NewapplicationService from '../../modules/NewapplicationService';
import { COMMON_ERROR_MSG, SESSION_TOKEN } from '../../constants/constants';
import {
  COMPLIANCE_ADMIN_ROLE_ID,
  LOAN_OFFICER_ROLE_ID,
} from "../../constants/DataConstants";
import _BankerService from "../../modules/BankerService";

const { Header, Content } = Layout;
const { confirm } = Modal;

const SidebarLayout = ({ children, location, history }) => {

  const [drawerVisible, setDrawerVisible] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [loading, setLoading] = useState(false);
  const isClient = JSON.parse(localStorage.getItem("IsClient") || "false");
  const isLoanOfficer = JSON.parse(localStorage.getItem("IsLoanofficerFlag") || "false");
  const IsBankAdmin = JSON.parse(localStorage.getItem("IsBankAdminFlag") || "false");
  const IsFirmAdmin = JSON.parse(localStorage.getItem("IsFirmAdminFlag") || "false");
  const userRole = localStorage.getItem("userRole");
  const isPrivateWealthAdvisor = userRole === PRIVATE_WEALTH_ADVISOR_ROLE;
  const isComplianceAdministrator = userRole === COMPLIANCE_ADMINISTRATOR_ROLE;
  const isUnderwriterBanker = userRole === UNDERWRITER_BANKER_ROLE;
  const isSeniorPrivateBanker = userRole === SENIOR_PRIVATE_BANKER_ROLE;

  //According role to new login page
  const IsFromNewClientLoginPage = JSON.parse(localStorage.getItem("IsFromNewClientLoginPage") || "false");

  let menuItems = [];
  if (isLoanOfficer) {
    menuItems = [
      {
        key: routes.loanOfficerDashboard.path,
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        matchPaths: [routes.loanOfficerDashboard.path],
      },
      {
        key: routes.loanApplicationsForLoanOfficer.path,
        icon: <FileTextOutlined />,
        label: 'Applications',
        matchPaths: [routes.loanApplicationsForLoanOfficer.path, routes.loanApplicationDetails.path],
      },
      {
        key: routes.newReports.path,
        icon: <BarChartOutlined />,
        label: 'Reports',
        matchPaths: [routes.newReports.path],
      },
      {
        key: routes.liveAccountBalancesForBanker.path,
        icon: <WalletOutlined />,
        label: 'Account Balances',
        matchPaths: [routes.liveAccountBalancesForBanker.path],
      },
      // {
      //   key: routes.dataInsightsForBanker.path,
      //   icon: <BarChartOutlined />,
      //   label: 'Data Insights',
      //   matchPaths: [routes.dataInsightsForBanker.path],
      // },
    ]
  }
  else if (IsBankAdmin) {
    menuItems = [
      {
        key: routes.bankadmindashboard.path,
        icon: <DashboardOutlined />,
        label: 'User Role Managment',
        matchPaths: [routes.bankadmindashboard.path],
      },
      {
        key: routes.changeHistory.path,
        icon: <HistoryOutlined />,
        label: 'Change History',
        matchPaths: [routes.changeHistory.path],
      },
    ];
  } else if (IsFirmAdmin && userRole === "FirmAdmin") {
    // IsFirmAdminFlag reflects whether this email HAS a Firm Administrator identity anywhere, not
    // whether the CURRENT view is Firm Admin -- it stays "true" even while actively viewing as Client
    // or as a Banker role (see ApplicantService.UserLogin, which never clears it on an IsFirmAdmin:false
    // switch, and banker-role logins which never touch it at all). Gating on userRole === "FirmAdmin"
    // (rather than !== "Applicant") ensures this Firm Admin menu only builds when that identity is the
    // one currently active, not whenever a stale flag happens to be true for some other active role.
    menuItems = [
      {
        key: routes.firmadmindashboard.path,
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        matchPaths: [routes.firmadmindashboard.path, routes.firmadminsponsersdetails.path],
      },
      {
        key: routes.liveAccountBalances.path,
        icon: <WalletOutlined />,
        label: 'Account Balances',
        matchPaths: [routes.liveAccountBalances.path],
      },
      {
        key: routes.advancesAndRepayments.path,
        icon: <RetweetOutlined />,
        label: 'Advances & Repayments',
        matchPaths: [routes.advancesAndRepayments.path],
      },
      {
        key: routes.newReports.path,
        icon: <BarChartOutlined />,
        label: 'Reports',
        matchPaths: [routes.newReports.path],
      },
      // {
      //   key: routes.dataInsights.path,
      //   icon: <BarChartOutlined />,
      //   label: 'Data Insights',
      //   matchPaths: [routes.dataInsights.path],
      // },

    ]
    if (localStorage.getItem("IsSwitchFirmAdmin") !== "true") {
      // Reports Enhancement (Sept 2026), Requirement #5: Reports must stay reachable for a Firm
      // Admin regardless of this flag -- carved out as a narrow exception rather than removing this
      // gate outright, since it's unclear whether wiping the rest of the menu here is relied on
      // elsewhere for a Firm Admin who hasn't gone through the "Switch to Firm Administrator" flow.
      menuItems = menuItems.filter((item) => item.key === routes.newReports.path);
    }
  }
  else if (localStorage.getItem("userRole") === "Applicant") {
    menuItems = [];
  }
  else if (isPrivateWealthAdvisor) {
    menuItems = [
      {
        key: routes.bankerdashboard.path,
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        matchPaths: [routes.bankerdashboard.path],
      },
      {
        key: routes.loanapplication.path,
        icon: <FileTextOutlined />,
        label: 'Applications',
        matchPaths: [routes.loanapplication.path, routes.loanApplicationDetails.path],
      },
      {
        key: routes.newReports.path,
        icon: <BarChartOutlined />,
        label: 'Reports',
        matchPaths: [routes.newReports.path],
      },
    ];
  }
  else if (isComplianceAdministrator) {
    menuItems = [
      {
        key: routes.complianceadmindashboard.path,
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        matchPaths: [routes.complianceadmindashboard.path],
      },
      {
        key: routes.loanApplicationsForComplianceAdmin.path,
        icon: <FileTextOutlined />,
        label: 'Applications',
        matchPaths: [routes.loanApplicationsForComplianceAdmin.path, routes.loanApplicationDetails.path],
      },
      {
        key: routes.complianceAdminFirmDashboard.path,
        icon: <UsergroupAddOutlined />,
        label: 'Firms',
        matchPaths: [routes.complianceAdminFirmDashboard.path, routes.complianceAdminFacilityDetails.path, routes.complianceAdminSponserDetails.path],
      },
      {
        key: routes.liveAccountBalancesForCompliance.path,
        icon: <WalletOutlined />,
        label: 'Account Balances',
        matchPaths: [routes.liveAccountBalancesForCompliance.path],
      },
      {
        key: routes.newReports.path,
        icon: <BarChartOutlined />,
        label: 'Reports',
        matchPaths: [routes.newReports.path],
      },
    ];
  }
  else {
    menuItems = [
      {
        key: routes.bankerdashboard.path,
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        matchPaths: [routes.bankerdashboard.path],
      },
      {
        key: routes.loanapplication.path,
        icon: <FileTextOutlined />,
        label: 'Applications',
        matchPaths: [routes.loanapplication.path, routes.loanApplicationDetails.path],
      },
      {
        key: routes.sponsors.path,
        icon: <UsergroupAddOutlined />,
        label: 'Credit Facility',
        matchPaths: [routes.sponsors.path, routes.addEditSponsers.path],
      },
      {
        key: routes.liveAccountBalancesForBanker.path,
        icon: <WalletOutlined />,
        label: 'Account Balances',
        matchPaths: [routes.liveAccountBalancesForBanker.path],
      },
      {
        key: routes.advancesAndRepaymentsForBanker.path,
        icon: <RetweetOutlined />,
        label: 'Advances and Repayments',
        matchPaths: [routes.advancesAndRepaymentsForBanker.path],
      },
      {
        key: routes.newReports.path,
        icon: <BarChartOutlined />,
        label: 'Reports',
        matchPaths: [routes.newReports.path],
      },
      // {
      //   key: routes.dataInsightsForBanker.path,
      //   icon: <BarChartOutlined />,
      //   label: 'Data Insights',
      //   matchPaths: [routes.dataInsightsForBanker.path],
      // },
    ];

    if (isUnderwriterBanker) {
      menuItems = menuItems.filter(
        (item) => item.key !== routes.sponsors.path
      );
      menuItems.splice(2, 0, {
        key: routes.complianceAdminFirmDashboard.path,
        icon: <UsergroupAddOutlined />,
        label: 'Firms',
        matchPaths: [routes.complianceAdminFirmDashboard.path, routes.complianceAdminFacilityDetails.path, routes.complianceAdminSponserDetails.path],
      });
    }

    if (isSeniorPrivateBanker) {
      menuItems.splice(3, 0, {
        key: routes.seniorBankerFirmDashboard.path,
        icon: <UsergroupAddOutlined />,
        label: 'Firms',
        matchPaths: [routes.seniorBankerFirmDashboard.path, routes.seniorBankerFacilityDetails.path, routes.complianceAdminSponserDetails.path],
      });
    }
  }

  const handleMenuClick = ({ key }) => {
    if (key !== location.pathname) {
      history.push(key);
    }
  };

  const showLogoutConfirm = () => {
    confirm({
      title: "Are you sure you want to logout?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "No",
      okType: "primary",   // ✅ YES = primary
      centered: true,
      className: "logout-confirm-modal",
      onOk: handleLogout,
    });
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    history.push(routes.loginNewPage.path);
  };

  const handleAvatarClick = () => {
    if (IsBankAdmin === true) {
      history.push(routes.bankadminprofile.path);
    }
    else if (isLoanOfficer === true) {
      history.push(routes.loanOfficerProfile.path);
    } else if (isLoanOfficer === false) {
      history.push(routes.bankerprofile.path);
    }
  };

  const userMenu = (
    <Menu className='user-dropdown-menu-logout'>
      <Menu.Item key="logout" icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />} onClick={showLogoutConfirm}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const profileMenu = (
    <Menu>
      <Menu.Item key="My Profile" icon={<UserOutlined />} onClick={handleAvatarClick} >
        My Profile
      </Menu.Item>
    </Menu>
  );



  const getSelectedKey = () => {
    const match = menuItems && menuItems.find(item =>
      item.matchPaths.some(p =>
        !!matchPath(location.pathname, { path: p, exact: false, strict: false })
      )
    );
    return match ? match.key : '';
  };

  const switchToApplicant = async (isFirmAdmin) => {

    let reqObj = {
      // Email: localStorage.getItem("loginEmail"),
      Email: localStorage.getItem("ApplicationEmailId") ? localStorage.getItem("ApplicationEmailId") : localStorage.getItem("loginEmail"),
      Password: localStorage.getItem("IsKey"),
      IsFirmAdmin: isFirmAdmin,
    }
    setLoading(true);
    try {
      const res = await _NewapplicationService.userLogin(reqObj);
      if (res.data.IsSuccess) {
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("ApplicationId", res?.data?.Obj?.Id);
        localStorage.setItem("BankerId", res?.data?.Obj?.BankerId);
        localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
        localStorage.setItem("Role", res?.data?.Obj?.Role);
        localStorage.setItem("FirmAdmin",JSON.stringify(res?.data?.Obj?.IsFirmAdmin ?? false));

        localStorage.setItem("IsFirmAdminFlag", res?.data?.Obj?.IsFirmAdmin);
        localStorage.setItem("HasOtherRoleAssociation", res?.data?.Obj?.HasOtherRoleAssociation);
        localStorage.setItem("SponserIdForFirmLogin", res?.data?.Obj?.SponserId);
        localStorage.setItem("ApplicationEmailId", res?.data?.Obj?.Email);
        localStorage.setItem("loginEmail", reqObj.Email);
        localStorage.setItem("IsKey", reqObj.Password);
        localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(isFirmAdmin));
        localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
        if (isFirmAdmin) {
          history.push({
            pathname: routes.firmadmindashboard.path,
            state: { "email": reqObj.Email }
          });
        }
        else {
          history.push({
            pathname: routes.myApplications.path,
            state: { "email": reqObj.Email }
          });
        }
        setLoading(false);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const combinedMenu = (
    <Menu className="user-dropdown-menu-logout">
      {/* Profile */}
      <Menu.Item
        key="profile"
        icon={<UserOutlined />}
        onClick={handleAvatarClick}

      >
        My Profile
      </Menu.Item>

      <Menu.Divider />

      {/* Logout */}
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />}
        onClick={showLogoutConfirm}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
  const isFirmAdminFlag = localStorage.getItem("IsFirmAdminFlag") === "true";
  // Only offer the Switch to Client/Switch to Firm Admin buttons when this person actually has another
  // Firm Admin/Applicant association to switch into -- isFirmAdminFlag alone is true for any Firm Admin,
  // even one with just a single facility.
  const hasOtherRoleAssociation = localStorage.getItem("HasOtherRoleAssociation") === "true";
  const renderMenu = () => {
    return (
      <>
        {screens.md ? (
          <>
            <Menu
              mode="horizontal"
              selectedKeys={[getSelectedKey()]}
              onClick={handleMenuClick}
              style={{ flex: 1, minWidth: 0 }}
            >
              {menuItems.map(({ key, icon, label }) => (
                <Menu.Item
                  key={key}
                // icon={icon}
                >
                  {label}
                </Menu.Item>
              ))}
            </Menu>

            {/* This Client<->Firm Admin switch only applies to those two identities -- gating on
                the exact userRole (rather than a plain else) keeps it from leaking into banker
                roles (Senior Private Banker, Underwriter Banker, Wealth Advisor, Loan Officer, etc.)
                whenever isFirmAdminFlag/hasOtherRoleAssociation are stale-true from another session. */}
            {isFirmAdminFlag && hasOtherRoleAssociation && userRole === "FirmAdmin" && (
              <Button
                type="primary"
                icon={<UserSwitchOutlined />}
                onClick={() => switchToApplicant(false)}
                className="side-bar-component__switch-button"
              >
                Switch to Client
              </Button>
            )}
            {isFirmAdminFlag && hasOtherRoleAssociation && userRole === "Applicant" && (
              <Button
                type="primary"
                icon={<UserSwitchOutlined />}
                onClick={() => switchToApplicant(true)}
                className="side-bar-component__switch-button"
              >
                Switch to Firm Administrator
              </Button>
            )}


            {roleSwitchDropdown()}

            {!(localStorage.getItem("IsFirmAdminFlag") === "true") && localStorage.getItem("userRole") !== "Applicant" ? (
              <Dropdown
                overlay={combinedMenu}
                trigger={['click']}
                placement="bottomRight"
                className="headerMenuUserAndLogOut"
              >
                <div className="user-dropdown-trigger">
                  <UserOutlined className="user-icon" />

                  <span className="user-role-text">
                    {/* {localStorage.getItem("userRole") === "FirmAdmin" ? "Firm Admin" :
                      localStorage.getItem("userRole") === "BankAdmin" ? "Bank Admin" :
                        localStorage.getItem("userRole") === "Applicant" ? "client" :
                          localStorage.getItem("userRole") === "Banker" ? "Banker" : "Credit"} */}

                    {userRole === "FirmAdmin" ? "Firm Administrator" :
                      userRole === "BankAdmin" ? "Super Admin" :
                        userRole === PRIVATE_WEALTH_ADVISOR_ROLE ? PRIVATE_WEALTH_ADVISOR_ROLE :
                          userRole === COMPLIANCE_ADMINISTRATOR_ROLE ? "Compliance Admin" :
                            userRole === "Applicant" ? "Client" :
                              userRole === "Senior Private Banker" ? "Senior Private Banker" :
                                userRole === "Portfolio Banker" ? "Portfolio Banker" :
                                  userRole === "Underwriter Banker" ? "Underwriter Banker" :
                                    "Loan Officer"}
                  </span>

                  <DownOutlined className="dropdown-arrow" />
                </div>
              </Dropdown>
            ) : <Dropdown
              overlay={userMenu}
              trigger={['click']}
              placement="bottomRight"
              className="headerMenuUserAndLogOut"
            >
              <div className="user-dropdown-trigger">
                <UserOutlined className="user-icon" />

                <span className="user-role-text">
                  {/* {localStorage.getItem("userRole") === "FirmAdmin" ? "Firm Admin" :
                    localStorage.getItem("userRole") === "BankAdmin" ? "Bank Admin" :
                      localStorage.getItem("userRole") === "Applicant" ? "client" :
                        localStorage.getItem("userRole") === "Banker" ? "Banker" : "Credit"} */}

                  {userRole === "FirmAdmin" ? "Firm Administrator" :
                    userRole === "BankAdmin" ? "Super Admin" :
                      userRole === PRIVATE_WEALTH_ADVISOR_ROLE ? PRIVATE_WEALTH_ADVISOR_ROLE :
                        userRole === COMPLIANCE_ADMINISTRATOR_ROLE ? "Compliance Admin" :
                          userRole === "Applicant" ? "Client" :
                            userRole === "Senior Private Banker" ? "Senior Private Banker" :
                              userRole === "Portfolio Banker" ? "Portfolio Banker" :
                                userRole === "Underwriter Banker" ? "Underwriter Banker" :
                                  "Loan Officer"}
                </span>

                <DownOutlined className="dropdown-arrow" />
              </div>
            </Dropdown>}
          </>
        ) : (
          <div className="side-bar-component__mobile-container">
            <Avatar
              icon={<MenuOutlined />}
              className="side-bar-component__avatar"
              onClick={() => setDrawerVisible(true)}
            />

            {/* {!(localStorage.getItem("IsFirmAdminFlag") == "true") && (
              <Dropdown overlay={profileMenu} trigger={['hover']}>
                <Avatar
                  icon={<UserOutlined />}
                  className="side-bar-component__avatar"
                />
              </Dropdown>
            )} */}

            {/* <Dropdown overlay={userMenu} trigger={['hover']} placement="bottomRight">
              <Avatar
                icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />}
                className="side-bar-component__avatar"
              />
            </Dropdown> */}
          </div>
        )}
      </>
    )
  }

  const listUserRoles = (() => {
    try {
      return JSON.parse(localStorage.getItem('listUserRoles')) || [];
    } catch {
      return [];
    }
  })();

  const handleRoleSwitch = async (roleItem) => {
    const password = localStorage.getItem('Password');
    // isSSOLogin is set on page load from SSOProvider (tenantInfo).
    // true  → Microsoft/Gmail/etc. login — skip password in the switch API call.
    // false → SQL login — password is required (existing behaviour unchanged).
    const isSSOLogin = JSON.parse(localStorage.getItem('isSSOLogin') || 'false');

    // Loan Officer is now a Banker+BankerRoles member like every other role here, so it goes
    // through the same BankerLogin call (passing RoleId=2) instead of the old, separate
    // LoanOfficerService.loanOfficerLogin call against the standalone LoanOfficer table.
    setLoading(true);

    try {
      const reqObj = {
        Email: roleItem.Email,
        Password: password,
        IsBanker: roleItem.RoleId == COMPLIANCE_ADMIN_ROLE_ID ? "Compliance" : "Banker",
        RoleId: roleItem.RoleId,
        IsSSOLogin: isSSOLogin
      };
      const res = await _BankerService.bankerLogin(reqObj);
      // debugger
      console.log(res);
      if (res?.data.IsSuccess) {
        const isLoanOfficer = roleItem.RoleId == LOAN_OFFICER_ROLE_ID;

        localStorage.setItem("IsLoanofficerFlag", JSON.stringify(isLoanOfficer));
        localStorage.setItem("BankerEmailId", res?.data?.Obj?.Email);
        localStorage.setItem("BankerId", res?.data?.Obj?.Id);
        localStorage.setItem("BankerFirstName", res?.data?.Obj?.FirstName);
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
        localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
        localStorage.setItem("listUserRoles", JSON.stringify(res?.data?.Obj?.listUserRoles));
        localStorage.setItem("Password", password);

        if (isLoanOfficer) {
          // Loan Officer's dashboard (GetLoanOfficerDashboardSummary) still keys off
          // LoanOfficerId in localStorage -- for a BankerLogin response that's the Banker.Id.
          localStorage.setItem("LoanOfficerEmailId", res?.data?.Obj?.Email);
          localStorage.setItem("LoanOfficerId", res?.data?.Obj?.Id);
          localStorage.setItem("LoanOfficerFirstName", res?.data?.Obj?.FirstName);
          localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
          history.push(routes.loanOfficerDashboard.path);
        } else if (roleItem.RoleId == COMPLIANCE_ADMIN_ROLE_ID) {
          localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
          localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
          localStorage.setItem("BankerId", res?.data?.Obj?.Id);
          history.push(routes.complianceadmindashboard.path);
        } else {
          localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
          localStorage.setItem("BankerId", res?.data?.Obj?.Id);
          history.push(routes.bankerdashboard.path);
        }
        setLoading(false);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const roleMenu = (
    <Menu className="switch-view-dropdown-menu">
      {listUserRoles.map((roleItem) => (
        <Menu.Item key={roleItem.RoleId} icon={<SwapOutlined />} onClick={() => handleRoleSwitch(roleItem)}>
          {roleItem.Role}
        </Menu.Item>
      ))}
    </Menu>
  );

  const roleSwitchDropdown = () => {
    return (
      !isClient && !IsFirmAdmin && listUserRoles.length > 0 && (
        <Dropdown overlay={roleMenu} placement="bottomRight" trigger={['click']}>
          <div className="user-dropdown-trigger">
            <SwapOutlined className="user-icon" />
            <span className="user-role-text">Switch View</span>
            <DownOutlined className="dropdown-arrow" />
          </div>
        </Dropdown>
      )
    )
  };


  return (
    <Spin spinning={loading}>
      <Layout>
        <Header className="side-bar-component__header">
          <img
            src={"/websiteLogo.png"}
            alt={"Logo"}
            className="side-bar-component__logo-img"
          />
          {renderMenu()}
        </Header>

        <Drawer
          placement="left"
          closable={false}
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
          width={260}
          className="drawer-container"
        >
          <div className="drawer-header">
            <img
              src={"/websiteLogo.png"}
              alt={"Logo"}
              className="drawer-header__logo"
            />
            <CloseOutlined
              onClick={() => setDrawerVisible(false)}
              className="drawer-header__close-icon"
            />
          </div>
          <Menu
            mode="inline"
            selectedKeys={[getSelectedKey()]}
            onClick={(e) => {
              handleMenuClick(e);
              setDrawerVisible(false);
            }}
            className="drawer-menu"
          >
            {menuItems.map(({ key, icon, label }) => (
              <Menu.Item
                key={key}
                icon={icon}
              >
                {label}
              </Menu.Item>
            ))}
          </Menu>
          {/* {localStorage.getItem("userRole") === "FirmAdmin" ? localStorage.getItem("IsSwitchFirmAdmin") === "true" ?

            <Menu>
              <Menu.Item key="Switch to Applicant" icon={<UserSwitchOutlined />} onClick={() => switchToApplicant(true)} >
                Switch to Applicant
              </Menu.Item>
            </Menu> :
            <Menu>
              <Menu.Item key="Switch to Firm Admin" icon={<UserSwitchOutlined />} onClick={() => switchToApplicant(true)} >
                Switch to Firm Admin
              </Menu.Item>
            </Menu> : ""
          } */}
          {isFirmAdminFlag && hasOtherRoleAssociation && userRole === "FirmAdmin" && (
            // Switch to Applicant
            <Menu>
              <Menu.Item
                key="switchApplicant"
                icon={<UserSwitchOutlined />}
                onClick={() => switchToApplicant(false)}
              >
                Switch to Applicant
              </Menu.Item>
            </Menu>
          )}
          {isFirmAdminFlag && hasOtherRoleAssociation && userRole === "Applicant" && (
            // Switch to Firm Admin
            <Menu>
              <Menu.Item
                key="switchFirmAdmin"
                icon={<UserSwitchOutlined />}
                onClick={() => switchToApplicant(true)}
              >
                Switch to Firm Admin
              </Menu.Item>
            </Menu>
          )}
          {!(localStorage.getItem("IsFirmAdminFlag") === "true") && localStorage.getItem("userRole") !== "Applicant" && (
            profileMenu
          )}
          {userMenu}
        </Drawer>

        {/* Main Page Content */}
        <Content
          style={{
            minHeight: 'calc(100vh - 75px)',
            overflow: 'visible',
            padding: "20px 20px",
            background: '#0F0F0F',
          }}

        >
          {children}
        </Content>
      </Layout>
    </Spin>
  );
};

export default withRouter(SidebarLayout);